/*
 * Elysian Edge redesign: keyboard and focus behaviour for the header (Sprint 2).
 *
 * Next's own script already opens a nav dropdown on Enter / Space, closes it on Esc and slides the mobile drawer in and out. Added here:
 *   - the dropdown's keyboard toggle link gets role="button", aria-haspopup, an aria-expanded that follows the open state, and a
 *     label that names the menu it opens;
 *   - Esc closes the dropdown and puts focus back on its toggle;
 *   - while the mobile drawer is open, Tab / Shift+Tab stay inside it, and when it closes focus returns to the menu button.
 * Everything works through delegated listeners and a MutationObserver, so it does not depend on when Next's script has run.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function burger() {
    return document.querySelector('#header-inner > .link-btn a[aria-controls="nav"]');
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length) && getComputedStyle(el).visibility !== 'hidden';
  }

  /* 1. Dropdown toggles: ARIA state and label ------------------------------------------------------------------ */
  function toggleLinks() {
    return document.querySelectorAll('#nav > ul[data-type="horizontal-nav"] > li.sub > a.toggle:not(.toggle-back)');
  }

  function syncToggle(link) {
    var li = link.parentElement;
    var open = li.classList.contains('toggle');
    link.setAttribute('aria-expanded', open ? 'true' : 'false');
    li.removeAttribute('aria-expanded'); // Next puts it on the <li>, where it means nothing to a screen reader
  }

  function prepareToggles() {
    var nav = document.getElementById('nav');
    if (!nav) return;
    var template = nav.getAttribute('data-ee-toggle-label') || '';
    toggleLinks().forEach(function (link) {
      if (link.dataset.eeReady) return;
      link.dataset.eeReady = '1';
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'true');
      var parent = link.parentElement.querySelector(':scope > a:not(.toggle)');
      if (template && parent) {
        link.setAttribute('aria-label', template.replace('%ITEM%', parent.textContent.trim()));
      }
      syncToggle(link);
    });
  }

  var navObserver = new MutationObserver(function (records) {
    records.forEach(function (record) {
      var li = record.target;
      if (li.nodeType !== 1 || !li.matches || !li.matches('#nav > ul > li.sub')) return;
      var link = li.querySelector(':scope > a.toggle:not(.toggle-back)');
      if (link) syncToggle(link);
    });
  });

  function observeNav() {
    var nav = document.getElementById('nav');
    if (!nav) return;
    prepareToggles();
    navObserver.observe(nav, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* 2. Esc closes the dropdown and returns focus to its toggle -------------------------------------------------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (html.classList.contains('m2a')) return; // the drawer is handled below
    var open = document.querySelector('#nav > ul[data-type="horizontal-nav"] > li.sub.toggle');
    if (!open) return;
    var hadFocus = open.contains(document.activeElement);
    var trigger = open.querySelector(':scope > a.toggle:not(.toggle-back)');
    // Next closes the dropdown in its own Esc handler; make sure, then restore focus.
    window.setTimeout(function () {
      open.classList.remove('toggle', 'mtoggle');
      if (trigger) syncToggle(trigger);
      if (hadFocus && trigger) trigger.focus();
    }, 0);
  }, true);

  /* 3. Mobile drawer: focus trap and focus return -------------------------------------------------------------- */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab' || !html.classList.contains('m2a')) return;
    var drawer = document.getElementById('nav');
    if (!drawer) return;
    var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), isVisible);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!drawer.contains(active)) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  var drawerWasOpen = html.classList.contains('m2a');
  new MutationObserver(function () {
    var open = html.classList.contains('m2a');
    if (drawerWasOpen && !open) {
      var button = burger();
      if (button && isVisible(button)) button.focus();
    }
    drawerWasOpen = open;
  }).observe(html, { attributes: true, attributeFilter: ['class'] });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeNav);
  } else {
    observeNav();
  }
  // Next's own script builds extra nav elements after DOMContentLoaded; pick up any toggles added later.
  window.addEventListener('load', prepareToggles);
})();
